"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updatePrintableLayer;
const Layer_1 = require("../../../models/layers/Layer");
const updateEditableTextLayer_1 = __importDefault(require("./updateEditableTextLayer"));
const either_1 = require("../../../types/either");
const unfoldProject_1 = __importDefault(require("./helpers/unfoldProject"));
const updateUserPhotoLayer_1 = __importDefault(require("./updateUserPhotoLayer"));
function updatePrintableLayer(project, action) {
  const unfoldedProjectResult = (0, unfoldProject_1.default)(project, action.printableId, action.layerId);
  if (unfoldedProjectResult.isLeft()) {
    return (0, either_1.left)(unfoldedProjectResult.value);
  }
  const {
    layer: existingLayer
  } = unfoldedProjectResult.value;
  switch (existingLayer.type) {
    case Layer_1.LAYER_TYPE_EDITABLE_TEXT:
      return (0, updateEditableTextLayer_1.default)(project, action);
    case Layer_1.LAYER_TYPE_EDITABLE_DESIGN_ASSET:
      /* This code is untested; if you find yourself here, uncomment the line below and rigorously smoke test until you feel
       * confident that the `updateEditableDesignAssetLayer` method works properly, then write unit tests for it and ship your PR
       */
      // return updateEditableDesignAssetLayer(project, action as UpdatePrintableLayer<Partial<EditableDesignAssetLayer>>);
      throw new Error('UNTESTED METHOD: updateEditableDesignAssetLayer! Please go to updatePrintableLayer.ts in au-js-sdk, uncomment the method call, and test it thoroughly before proceeding.');
    case Layer_1.LAYER_TYPE_USER_PHOTO:
      return (0, updateUserPhotoLayer_1.default)(project, action);
    default:
      throw new Error(`The updatePrintableLayer action does not support layers of type "${action.layerUpdates.type}"`);
  }
}